<template>
  <b-card no-body class="mt-8 border-none">
    <div class="related-products text-center  ">
      <div class="related-headings font-bold text-left text-xl ">
        Templates
      </div>
      <swiper :options="swiperOption" class="related-product-swiper p-8 ">
        <swiper-slide
          v-for="item in related_items"
          :key="item.objectId"
          class=" rounded cursor-pointer rounded-lg shadow-lg mx-4 my-8"
        >
          <!-- Item Image -->
          <div class="img-container flex justify-center ">
            <img
              class="responsive cust-h150px w-full object-cover"
              :src="item.image"
              :alt="item.name"
            />
          </div>

          <!-- Item Heading -->
          <div class="item-heading py-4">
            <h6
              class=" font-semibold truncate  text-start text-primary font-bold"
            >
              {{ item.name }}
            </h6>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </b-card>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      related_items: [
        {
          name: "Template 1",

          image: require("../img/t1.jpg")
        },
        {
          name: "Template 2",

          image: require("../img/t2.jpg")
        },
        {
          name: "Template 3",

          image: require("../img/t3.jpg")
        },
        {
          name: "Template 4",
          brand: "Celebrity",
          price: 9000,
          image: require("../img/t1.jpg"),
          rating: 4,
          objectID: "5546604"
        },
        {
          name: "Template 1",
          brand: "Celebrity",
          price: 9000,
          image: require("../img/t2.jpg"),
          rating: 4,
          objectID: "5546604"
        },
        {
          name: "Template 1",
          brand: "Celebrity",
          price: 9000,
          image: require("../img/t3.jpg"),
          rating: 4,
          objectID: "5546604"
        }
      ],
      products: [],
      aiabID: "6018c6b90b29261798c027b5"
    };
  }
};
</script>

<style lang="scss">
#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .image-div {
    display: flex;
    flex-flow: row;
  }

  .image > img {
    margin: auto 6px;
    height: 60px;
    width: 60px;
  }

  .item-features {
    background-color: #f7f7f7;
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
          0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
.cust-h150px {
  height: 150px;
}
</style>
